/*
 * @Author: mrzou
 * @Date: 2021-07-13 10:43:41
 * @LastEditors: mrzou
 * @LastEditTime: 2021-07-28 14:32:01
 * @Description: file content
 */
import Vue from 'vue';
import { PageTrack, ClickTrack } from '~/utils/report';
Vue.prototype.$report = ClickTrack;

Vue.mixin({
	mounted() {
		const RouterData = (this.$vnode && this.$vnode.data) || {};
		// 如果是路由组件 并且 未开启 缓存 则执行埋点
		if (RouterData.routerView && !RouterData.keepAlive) {
			PageTrack({ vm: this });
		}
	},
	activated() {
		// 如果是路由组件 且是开启缓存 则埋点
		const vnode = this.$vnode;
		if (vnode.data && vnode.data.routerView) {
			PageTrack({ vm: this });
		}
	}
});
